import 'bootstrap/dist/css/bootstrap.css';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { configs } from './configurations';
import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

//  The user service base URL arrives at container start in window._env_, so it has to be
//  read at runtime rather than baked in. Until it resolves there is nothing to render:
//  AuthProvider needs it to be able to log anyone in.
function Root() {
    const [userBaseUrl, setUserBaseUrl] = useState(null);

    useEffect(() => {
        let mounted = true;
        configs().then((config) => {
            if (mounted) setUserBaseUrl(config.userBaseUrl || '');
        });

        return () => {
            mounted = false;
        };
    }, []);

    if (userBaseUrl === null) return null;

    return (
        <AuthProvider userBaseUrl={userBaseUrl}>
            <BrowserRouter basename={baseUrl}>
                <App />
            </BrowserRouter>
        </AuthProvider>
    );
}

ReactDOM.render(
    <React.Fragment>
        <Root />
    </React.Fragment>
    , rootElement);

registerServiceWorker();
